export default __webpack_public_path__ + "static/media/icon-defaut-product.553e147e.svg";